/* Gospel Archive — global interactions: mobile menu, search dialog, focus trap utility. */
(function () {
  'use strict';

  /** Traps focus within `el` while active; returns a release function. */
  function trapFocus(el, initialFocusEl) {
    var focusable = el.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return function () {};
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    function onKeydown(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    el.addEventListener('keydown', onKeydown);
    (initialFocusEl || first).focus();

    return function release() {
      el.removeEventListener('keydown', onKeydown);
    };
  }

  window.GA = window.GA || {};
  window.GA.trapFocus = trapFocus;

  function openDialog(dialog, opener) {
    dialog.hidden = false;
    dialog.dataset.opener = '';
    dialog._release = trapFocus(dialog);
    dialog._opener = opener;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', dialog._escHandler = function (e) {
      if (e.key === 'Escape') closeDialog(dialog);
    });
  }

  function closeDialog(dialog) {
    dialog.hidden = true;
    document.body.style.overflow = '';
    if (dialog._release) dialog._release();
    document.removeEventListener('keydown', dialog._escHandler);
    if (dialog._opener) dialog._opener.focus();
  }

  window.GA.openDialog = openDialog;
  window.GA.closeDialog = closeDialog;

  // Mobile menu
  var mobileMenu = document.getElementById('MobileMenu');
  document.querySelectorAll('[data-mobile-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () { openDialog(mobileMenu, btn); });
  });
  if (mobileMenu) {
    mobileMenu.querySelectorAll('[data-mobile-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeDialog(mobileMenu); });
    });
  }

  // Search dialog
  var searchDialog = document.getElementById('SearchDialog');
  document.querySelectorAll('[data-search-open]').forEach(function (btn) {
    btn.addEventListener('click', function () { openDialog(searchDialog, btn); });
  });
  if (searchDialog) {
    searchDialog.querySelectorAll('[data-search-close]').forEach(function (el) {
      el.addEventListener('click', function () { closeDialog(searchDialog); });
    });
  }

  // Generic dialogs (size guide, and any future aria-haspopup="dialog" trigger)
  document.querySelectorAll('[data-size-guide-open]').forEach(function (btn) {
    var dialog = document.getElementById(btn.getAttribute('aria-controls'));
    if (!dialog) return;
    btn.addEventListener('click', function () { openDialog(dialog, btn); });
    dialog.querySelectorAll('[data-size-guide-close]').forEach(function (el) {
      el.addEventListener('click', function () { closeDialog(dialog); });
    });
  });
})();
